import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import FormsDataContext, {FormsData} from 'contexts/FormsDataContext';

export type WithFormsDataProps = {
    formsData: FormsData;
};

export default function withFormsData<T extends WithFormsDataProps>(
    WrappedComponent: React.ComponentType<T>,
) {
    class WithFormsData extends React.Component<Omit<T, keyof WithFormsDataProps>> {
        static displayName = `withFormsData(${
            WrappedComponent.displayName || WrappedComponent.name || 'Component'
        })`;
        static contextType = FormsDataContext;

        render() {
            return <WrappedComponent {...(this.props as T)} formsData={this.context} />;
        }
    }

    // Copies non-react specific statics from a child component to a parent component
    hoistNonReactStatics(WithFormsData, WrappedComponent);
    return WithFormsData;
}
